export default function({ state, commit, dispatch }, query) {
    // Optimization: if all patients have been loaded, further queries are not necessary

    commit('startLoadingPatients')
    let emailArr = []

    if(query && query.email)
        emailArr = query.email.split(',')

    return dispatch('post', {
        url: '/provider/' + state.id + '/patients',
        data: {
            email: emailArr
        }
    }, {
        root: true
    })
    .then((response) => {
        commit('finishLoadingPatients')
        // Setting the scheduleEventMap from the `provider_map` recieved
        // to match events to provider from the state later
        if(response.provider_map)
            commit('addscheduledEventMap', response.provider_map)
        
        return response.patients
    })
    .catch((error) => {
        commit('finishLoadingPatients')
        throw error
    })
}
